import { FC, ReactNode } from 'react';

import classNames from 'classnames';

import { dataTestValue } from '@telialt/utils/src/helpers';

type Modifier =
    | 'pull-left'
    | 'pull-right'
    | 'force-wrap'
    | 'full'
    | 'full-xs'
    | 'inline'
    | 'inline-sm'
    | 'inline-md'
    | 'inline-lg'
    | 'clear'
    | 'clear-right';

type Props = {
    children?: ReactNode;
    modifier?: Modifier | Modifier[];
    className?: string;
    dataTest?: string;
};

const ButtonGroup: FC<Props> = ({ children, modifier, className, dataTest }) => {
    const modifiers = Array.isArray(modifier) ? modifier : [modifier];
    const modifierList = modifier ? modifiers.map((item) => `button-group--${item}`) : null;

    const buttonGroupClassNames = classNames('button-group', modifierList, className);

    return (
        <div className={buttonGroupClassNames} data-test={dataTestValue('button-group--container', null, dataTest)}>
            {children}
        </div>
    );
};

export default ButtonGroup;
